import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { FormController } from './FormController';
import { dateToUTC, handleError } from './Functions';

export function EditModal({
        modelId, parentId, parentsParentId, data, modelName, setShow, setLoading, loading, isEdit,
        editEndpoint, extraEndpoint, deleteEndpoint, viewKeys, editKeys, extraKeys, hardDelete,
        canReadUserRoles, canReadServiceAddresses, canReadMeters, districtId }) {
    const [editMode, setEditMode] = useState(false);
    const [model, setModel] = useState<any>();
    const keys: string[] = (editMode ? editKeys : viewKeys)

    useEffect(() => {
        setModel(data)
    }, [data])

    useEffect(() => {
        setEditMode(isEdit)
    }, [isEdit])

    const handleCancel = () => {
        setEditMode(false)
        setShow(false)
    }

    const handleEdit = async event => {
        event.preventDefault();

        let editModel = {};
        for (var obj in model) {
            if(model[obj] !== "")
                editModel[obj] = model[obj];
            if(obj.toLowerCase().endsWith("date") && !(model[obj] instanceof Date))
                editModel[obj] = dateToUTC(new Date(new Date(new Date(model[obj]).setDate(1+new Date(new Date(model[obj])).getDate())).setHours(0)))
        }

        if(parentsParentId) {
            editEndpoint(parentsParentId, parentId, modelId, editModel)
                .then(() => setLoading(!loading))
                .catch(err => handleError(err))
        } else if(parentId) {
            editEndpoint(parentId, modelId, editModel)
                .then(() => setLoading(!loading))
                .catch(err => handleError(err))
            if(extraKeys)
                extraEndpoint(parentId, modelId, editModel)
                    .then(() => setLoading(!loading))
                    .catch(err => handleError(err))
        } else {
            editEndpoint(modelId, editModel)
                .then(() => setLoading(!loading))
                .catch(err => handleError(err))
            if(extraKeys)
                extraEndpoint(modelId, editModel)
                    .then(() => setLoading(!loading))
                    .catch(err => handleError(err))
        }
        handleCancel();
    };

    const setActiveState = () => {
        let confirm = window.confirm("Are you sure you want to do this?");

        if (confirm === true) {
            let newActiveState = model.isActive ? false : true;

            setModel((prevState) => ({
                ...prevState,
                isActive: newActiveState
            }));

            if(parentId) {
                editEndpoint(parentId, modelId, { ...model, isActive: newActiveState })
                .then(() => setLoading(!loading))
                .catch(err => handleError(err));
            } else {
                editEndpoint(modelId, { ...model, isActive: newActiveState })
                .then(() => setLoading(!loading))
                .catch(err => handleError(err));
            }
            handleCancel();
        }
    };

    const setDelete = () => {
        let confirm = window.confirm("Are you sure you want to do this?");

        if (confirm === true) {
            if(parentsParentId) {
                deleteEndpoint(parentsParentId, parentId, modelId)
                    .then(() => setLoading(!loading))
                    .catch(err => handleError(err))
            } else if(parentId){
                deleteEndpoint(parentId, modelId)
                    .then(() => setLoading(!loading))
                    .catch(err => handleError(err))
            } else {
                deleteEndpoint(modelId)
                    .then(() => setLoading(!loading))
                    .catch(err => handleError(err))
            }

            handleCancel();
        }
    };
    if(model === undefined) return null;

    return (
        <Dialog
        open={true}
        onClose={handleCancel}
        aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Edit {modelName}</DialogTitle>
            <DialogContent>
                <FormController
                    keys={keys}
                    disabledKeys={[]}
                    extraKeys={extraKeys}
                    editMode={isEdit || editMode}
                    model={model}
                    setModel={setModel}
                    canReadUserRoles={canReadUserRoles}
                    canReadMeters={canReadMeters}
                    canReadServiceAddresses={canReadServiceAddresses}
                    districtId={districtId} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>
                    Cancel
                </Button>
                {keys.hasOwnProperty("isActive") &&
                    <Button
                        hidden={hardDelete || !editMode}
                        color="secondary"
                        onClick={setActiveState}
                    >
                        {model.isActive ? "Deactivate" : "Activate"}
                    </Button>
                }
                <Button
                    hidden={!editMode || !hardDelete}
                    color="secondary"
                    onClick={setDelete}
                >
                    Delete
                </Button>
                <Button
                    hidden={!editMode}
                    onClick={handleEdit}
                    color="primary"
                >
                    Save
                </Button>
                <Button
                    hidden={editMode}
                    onClick={() => setEditMode(true)}
                    color="primary"
                >
                    Edit
                </Button>
            </DialogActions>
        </Dialog>
    );
}